import { MessagesSquare } from '@music-vine/cadence/icons';
import Link from 'next/link';
import { Button } from '@music-vine/cadence/ui';
export const GotQuestions = () => <div className="flex flex-row flex-wrap items-center justify-between gap-2 rounded-lg bg-gray-100 px-6 py-5 dark:bg-gray-800" data-sentry-component="GotQuestions" data-sentry-source-file="GotQuestions.tsx">
    <div className="flex flex-wrap items-center gap-2">
      <MessagesSquare className="size-6 text-pink-500" data-sentry-element="MessagesSquare" data-sentry-source-file="GotQuestions.tsx" />{' '}
      <span className="font-semibold dark:text-white">Got questions?</span>
    </div>
    <Button asChild size="default" variant="bold" data-sentry-element="Button" data-sentry-source-file="GotQuestions.tsx">
      <Link href="/help-center/general-faqs" data-sentry-element="Link" data-sentry-source-file="GotQuestions.tsx">Go to help center</Link>
    </Button>
  </div>;